import React from 'react';
import './PreviewImage.css'

type IPreviewImageProps = {
	image?: string;
	onClose: () => void;
};

export const PreviewImage = (props: IPreviewImageProps) => {
	const { image, onClose } = props;
	return (
		<>
			{image && (
				<div className='overlay dismiss' onClick={onClose}>
					<img src={image} alt={image} />
					<button type='button' className='inline-flex items-center rounded-md border border-input bg-background px-2 py-1 text-sm hover:bg-muted' onClick={() => onClose}>
						X
					</button>
					<p className='detail text-center ff-italic'>{image}</p>
				</div>
			)}
		</>
	);
};
